import { useEffect } from "react";
import React from "react";
import "@/App.css";
import {
    BrowserRouter,
    Routes,
    Route,
    useLocation,
} from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsappFloat from "@/components/WhatsappFloat";
import Home from "@/pages/Home";
import Servizi from "@/pages/Servizi";
import Bandi from "@/pages/Bandi";
import FullRemote from "@/pages/FullRemote";
import ChiSiamo from "@/pages/ChiSiamo";
import Contatti from "@/pages/Contatti";
import Legal, { Privacy, Cookie } from "@/pages/Legal";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-ink">
                    <p className="text-slate-400">Si è verificato un errore. Ricarica la pagina.</p>
                </div>
            );
        }
        return this.props.children;
    }
}

const ScrollManager = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        if (window.__lenis) {
            window.__lenis.scrollTo(0, { immediate: true, force: true });
        } else {
            window.scrollTo(0, 0);
        }
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <BrowserRouter>
                <ScrollManager />
                <div className="grain" aria-hidden="true" />
                <Header />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/servizi" element={<Servizi />} />
                        <Route path="/bandi-finanza-agevolata" element={<Bandi />} />
                        <Route path="/full-remote" element={<FullRemote />} />
                        <Route path="/chi-siamo" element={<ChiSiamo />} />
                        <Route path="/contatti" element={<Contatti />} />
                        <Route path="/privacy-policy" element={<Privacy />} />
                        <Route path="/cookie-policy" element={<Cookie />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </main>
                <Footer />
                <WhatsappFloat />
                <Toaster position="top-right" theme="dark" toastOptions={{ style: { background: "#101724", border: "1px solid rgba(255,255,255,0.1)", color: "#E7ECF3" } }} />
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
